import { OfferModel } from '$store/models';
import { useSelector } from 'react-redux';
import { offersSelector } from '$store/offers';

export function useOffer(offerId: number): OfferModel | null {
  const { offersInfo } = useSelector(offersSelector);
  return offersInfo[offerId] || null;
}
